import React from 'react';
const logos = [{
  name: 'Marriott',
  src: 'https://cdn.magicpatterns.com/uploads/pZq39H4Gtmhnx3YZTmw253/Marriot.webp'
}, {
  name: 'Hilton',
  src: 'https://cdn.magicpatterns.com/uploads/iuKxa1ywBRTHoPwoZh5qDE/Hilton.webp'
}, {
  name: 'Beverly Wilshire',
  src: 'https://cdn.magicpatterns.com/uploads/hL2Hpy2ELgwXwcGZGc72e6/BW.webp'
}, {
  name: 'SLS Hotels',
  src: 'https://cdn.magicpatterns.com/uploads/9myFL4ZY8iFjudfDsxDtbw/SLS.webp'
}, {
  name: 'Arrive Hotels',
  src: 'https://cdn.magicpatterns.com/uploads/pPUv9YhPjpgfuSiNeGbmuw/Arrive.webp'
}, {
  name: 'Sysco',
  src: 'https://cdn.magicpatterns.com/uploads/wQxubasPHyjWuhhixNSYvG/Sysco.webp'
}, {
  name: 'US Foods',
  src: 'https://cdn.magicpatterns.com/uploads/frbUHhN5nMz4P2PmgvtZ54/USFoods.webp'
}, {
  name: 'UNFI',
  src: 'https://cdn.magicpatterns.com/uploads/jVV8BZvMuHcPTsLyUsc6sr/Unfi.webp'
}, {
  name: 'Starfish Laguna Beach',
  src: 'https://cdn.magicpatterns.com/uploads/5X75YhzJF1iHxmujfLbUFX/Starfish.webp'
}];
export const LogoCarousel = ({
  className = ''
}: {
  className?: string;
}) => {
  return <section className={`py-14 md:py-20 bg-white overflow-hidden ${className}`} data-id="element-65">
      <div className="container mx-auto px-4 md:px-6 lg:px-12 mb-10 text-center" data-id="element-66">
        <h2 className="text-2xl md:text-3xl font-light text-gray-900" data-id="element-67">
          Trusted by Leading Hospitality Brands
        </h2>
      </div>

      <div className="relative w-full overflow-hidden" data-id="element-68">
        {/* Fade edges */}
        <div className="absolute left-0 top-0 bottom-0 w-20 md:w-32 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" data-id="element-69" />
        <div className="absolute right-0 top-0 bottom-0 w-20 md:w-32 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" data-id="element-70" />

        <div className="flex w-max animate-logo-scroll hover:[animation-play-state:paused]" data-id="element-71">
          {/* First set */}
          <div className="flex items-center gap-16 md:gap-24 px-8 md:px-12" data-id="element-72">
            {logos.map((logo, index) => <div key={`logo-1-${index}`} className="flex-shrink-0 flex items-center justify-center h-12 md:h-16" data-id="element-73">
                <img src={logo.src} alt={logo.name} className="h-full w-auto max-w-[160px] md:max-w-[200px] object-contain opacity-70 grayscale hover:opacity-100 hover:grayscale-0 transition-all duration-300" data-id="element-74" />
              </div>)}
          </div>
          {/* Duplicate for seamless loop */}
          <div className="flex items-center gap-16 md:gap-24 px-8 md:px-12" data-id="element-75">
            {logos.map((logo, index) => <div key={`logo-2-${index}`} className="flex-shrink-0 flex items-center justify-center h-12 md:h-16" data-id="element-76">
                <img src={logo.src} alt={logo.name} className="h-full w-auto max-w-[160px] md:max-w-[200px] object-contain opacity-70 grayscale hover:opacity-100 hover:grayscale-0 transition-all duration-300" data-id="element-77" />
              </div>)}
          </div>
        </div>
      </div>

      <style data-id="element-78">{`
        @keyframes logoScroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .animate-logo-scroll {
          animation: logoScroll 30s linear infinite;
        }
      `}</style>
    </section>;
};